/**
 * ScoreRing — a compact circular progress indicator for a 0–100 score.
 *
 * Colour is derived from the score band (green / amber / red) so the customer
 * dashboard reads at a glance, matching the report's grade colouring.
 */

function ringColor(score: number): string {
  if (score >= 80) return '#16a34a' // green  — strong
  if (score >= 50) return '#d97706' // amber  — needs work
  return '#ef042d' //                red    — Cartley brand / poor
}

interface Props {
  score: number
  size?: number
  stroke?: number
  showValue?: boolean
}

export function ScoreRing({ score, size = 44, stroke = 4, showValue = true }: Props) {
  const clamped = Math.max(0, Math.min(100, Math.round(score)))
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (clamped / 100) * circumference
  const color = ringColor(clamped)

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#eef0f4"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.6s ease' }}
        />
      </svg>
      {showValue && (
        <span
          className="absolute inset-0 flex items-center justify-center text-xs font-semibold"
          style={{ color }}
        >
          {clamped}%
        </span>
      )}
    </div>
  )
}
